function LazyLoad() {
  // Aplicando listener para quando a pagina estiver carregada
  $(function () {

    // Selecionando os elementos que utilizam lazy loading
    const elements = document.querySelectorAll('[data-lazy-attribute]');
    if (!elements.length) {
      return;
    }

    // aplicando o atributo do elemento para liberar o carregamento
    elements.forEach((element) => {
      const attribute = element.dataset.lazyAttribute;
      element.setAttribute(attribute, element.dataset[attribute]);
    });
  });
}

module.exports = {
  init: LazyLoad
}
